import { FC, useCallback, useEffect, useMemo, useState } from "react";

import Icon from "../Icon";
import PaginationButton from "../PaginationButton/PaginationButton";
import {
  StyledLeftColumnHeader,
  StyledWrapper,
  WrapperButtons,
  ButtonSearch,
  TextFilter,
  FormLabelStyled,
  RadioGroupStyled,
  FormControlLabelStyled,
  ButtonWithIcon,
} from "./styles";
import { LeftColumnProps } from "./types";
import LeftColumnItem from "./LeftColumnItem/LeftColumnItem";
import iconLupa from "./../../assets/icons/svgs/icon_lupa (2).svg";
import { getTotalCustomers } from "../../../services/api/customers/CustomersService";
import { getAllAreasIdsAndNames } from "../../../services/api/areas/AreasService";
import { getAllPositionsIdsAndNames } from "../../../services/api/positions/PositionsService";
import { getAllProjectsIdsAndNames } from "../../../services/api/projects/projectService";
import { IKeyValue } from "../../../@types/key-value.type";
import { useAllocation } from "../../hooks/useAllocations";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs, { Dayjs } from "dayjs";
import { useCalendar } from "../../context/CalendarProvider";
import { searchAllocations } from "../../../services/api/Allocations/AllocationsService";
import { getAllCostCentersIdsAndNames } from "../../../services/api/costCenter/costCenterService";
import secureLocalStorage from "react-secure-storage";
import Menu from "@mui/material/Menu/Menu";
import MenuItem from "@mui/material/MenuItem/MenuItem";
import Radio from "@mui/material/Radio/Radio";
import FormControl from "@mui/material/FormControl/FormControl";
import TextField from "@mui/material/TextField/TextField";
import Autocomplete from "@mui/material/Autocomplete/Autocomplete";
import Checkbox from "@mui/material/Checkbox";
import AddIcon from "@mui/icons-material/Add";
import { ModalFormAlocation } from "../ModalFormAllocation";

const LeftColumn: FC<LeftColumnProps> = ({
  data,
  rows,
  onLoadNext,
  onLoadPrevious,
  pageNum,
  pagesAmount,
  onItemClick,
}) => {
  const {
    isLoading,
    allocations,
    setAllocations,
    setIsLoading,
    setTotalAllocations,
    areaSelected,
    costCenterSelected,
    clientSelected,
    positionSelected,
    projectSelected,
    searchResource,
    valueCategories,
    setAreaSelected,
    setCostCenterSelected,
    setClientSelected,
    setPositionSelected,
    setProjectSelected,
    setValueCategories,
    setSearchResource,
    getNumberValueAndIdFromCategories,
    range,
    hasFilters,
  } = useAllocation();

  const { handleDatePerMonthAndYear, date, zoom } = useCalendar();

  const [selectedDate, setSelectedDate] = useState(dayjs());
  const [isInitialRender, setIsInitialRender] = useState(true);
  const [projects, setProjects] = useState<IKeyValue[]>([]);
  const [clients, setClients] = useState<IKeyValue[]>([]);
  const [positions, setPositions] = useState<IKeyValue[]>([]);
  const [areas, setAreas] = useState<IKeyValue[]>([]);
  const [costCenters, setCostCenters] = useState<IKeyValue[]>([]);
  const [btnActive, setBtnActive] = useState<"agroup" | "search" | null>(null);
  const [anchorSearch, setAnchorSearch] = useState<null | HTMLElement>(null);
  const openSearch = Boolean(anchorSearch);
  const [openModal, setOpenModal] = useState(false);
  const handleOpenModal = () => setOpenModal(true);
  const handleCloseModal = () => setOpenModal(false);
  const [projectInputValue, setProjectInputValue] = useState<string>("");
  const [customerInputValue, setCustomerInputValue] = useState<string>("");
  const [positionInputValue, setPositionInputValue] = useState<string>("");
  const [areaInputValue, setAreaInputValue] = useState<string>("");
  const [costCenterInputValue, setCostCenterInputValue] = useState<string>("");

  const countAllocations = useMemo(() => {
    return allocations.length;
  }, [allocations]);

  const handleDateChange = (newDate: Dayjs | null) => {
    handleDatePerMonthAndYear(newDate as Dayjs);
    setSelectedDate(newDate as Dayjs);
  };

  const handleChangeCategories = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setValueCategories((event.target as HTMLInputElement).value);
  };

  const handleChangeResource = (event: React.ChangeEvent<HTMLInputElement>) => {
    handleResetFilters();
    const value = event.target.value.trimStart();
    setSearchResource(value);
  };

  const handleClickSearch = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorSearch(event.currentTarget);
  };

  const handleCloseFilters = () => {
    setAnchorSearch(null);
    setBtnActive(null);
  };

  const handleResetFilters = () => {
    setClientSelected([]);
    setPositionSelected([]);
    setProjectSelected([]);
    setAreaSelected([]);
    setCostCenterSelected([]);
    setSearchResource("");

    setStorageSearchParamsAllocationsMap();
  };

  const setStorageSearchParamsAllocationsMap = () => {
    const searchParamsAllocationMap = {
      valueCategoriesStorage: valueCategories,
      searchResourceStorage: searchResource,
      projectSelectedStorage: projectSelected,
      clientSelectedStorage: clientSelected,
      positionSelectedStorage: positionSelected,
      areSelectedStorage: areaSelected,
      costCenterSelectedStorage: costCenterSelected,
    };

    secureLocalStorage.setItem(
      "searchParamsAllocationMap",
      JSON.stringify(searchParamsAllocationMap)
    );
  };

  const handleClearFilters = () => {
    setValueCategories("0");
    handleResetFilters();
  };

  useEffect(() => {
    const fetchDataCategories = async () => {
      try {
        const [
          clientsRes,
          areasRes,
          positionsRes,
          projectsRes,
          costCentersRes,
        ] = await Promise.allSettled([
          getTotalCustomers(),
          getAllAreasIdsAndNames(),
          getAllPositionsIdsAndNames(),
          getAllProjectsIdsAndNames(),
          getAllCostCentersIdsAndNames(),
        ]);

        if (clientsRes.status === "fulfilled")
          setClients(clientsRes.value.result);
        if (areasRes.status === "fulfilled")
          setAreas(areasRes.value as IKeyValue[]);
        if (positionsRes.status === "fulfilled")
          setPositions(positionsRes.value as IKeyValue[]);
        if (projectsRes.status === "fulfilled")
          setProjects(projectsRes.value as IKeyValue[]);
        if (costCentersRes.status === "fulfilled")
          setCostCenters(costCentersRes.value as IKeyValue[]);
      } catch (error) {
        console.log(error);
      }
    };

    fetchDataCategories();
  }, []);

  const fetchAllocations = useCallback(async () => {
    const { idCategorieArray, numberValueCategories } =
      getNumberValueAndIdFromCategories();

    try {
      setIsLoading(true);

      setStorageSearchParamsAllocationsMap();

      let endDateToApi;
      switch (zoom) {
        case 1:
          endDateToApi = selectedDate.endOf("month").startOf("day").toDate();
          break;
        case 0:
          endDateToApi = selectedDate
            .add(2, "month")
            .endOf("month")
            .startOf("day")
            .toDate();
          break;
        case 3:
          endDateToApi = selectedDate
            .add(5, "month")
            .endOf("month")
            .startOf("day")
            .toDate();
          break;
        case 4:
          endDateToApi = selectedDate
            .add(11, "month")
            .endOf("month")
            .startOf("day")
            .toDate();
          break;
        default:
          endDateToApi = selectedDate
            .add(4, "month")
            .endOf("month")
            .startOf("day")
            .toDate();
          break;
      }

      const response = await searchAllocations(
        0,
        500,
        numberValueCategories,
        searchResource.trim(),
        idCategorieArray?.map((item) => item.key),
        selectedDate.startOf("month").toDate(),
        endDateToApi
      );

      if (response && 'result' in response) {
        setAllocations(response.result.items);
        setTotalAllocations(response.result.totalRows);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  }, [
    selectedDate,
    zoom,
    searchResource,
    areaSelected,
    clientSelected,
    projectSelected,
    positionSelected,
    costCenterSelected,
    valueCategories,
  ]);

  useEffect(() => {
    if (isInitialRender) {
      setIsInitialRender(false);
      return;
    }

    setIsLoading(true);

    if (searchResource?.trim() !== "") {
      const timeoutId = setTimeout(() => {
        fetchAllocations();
      }, 1000);

      return () => clearTimeout(timeoutId);
    } else {
      fetchAllocations();
    }
  }, [fetchAllocations]);

  useEffect(() => {
    let date = range.startDate;
    date.setDate(date.getDate() + 1);

    let newDate = dayjs(
      new Date(date.getFullYear(), date.getMonth(), date.getDay())
    );

    if (newDate.month() != date.getMonth())
      newDate = newDate.add(1, "month");

    setSelectedDate(newDate);
  }, [range]);

  return (
    <>
      <StyledWrapper>
        <StyledLeftColumnHeader>
          <WrapperButtons>
            <TextFilter>Filtrar:</TextFilter>
            <div>
              <ButtonSearch
                isActive={btnActive}
                onClick={(e) => {
                  handleClickSearch(e);
                  setBtnActive("search");
                }}
              >
                <Icon
                  iconName={hasFilters ? "iconFiltered" : "iconFilter"}
                  height="28"
                  width="28"
                />
              </ButtonSearch>

              <Menu
                anchorEl={anchorSearch}
                open={openSearch}
                onClose={handleCloseFilters}
              >
                <MenuItem
                  onKeyDown={(e) => {
                    e.stopPropagation();
                  }}
                >
                  <FormControl style={{ width: "100%", cursor: "default" }}>
                    <FormLabelStyled>
                      Categorias
                      {hasFilters && !isLoading && (
                        <>
                          <button onClick={handleClearFilters}>(Limpar)</button>
                          <div
                            onClick={() =>
                              countAllocations > 0 && handleOpenModal()
                            }
                            style={{
                              marginLeft: "auto",
                            }}
                          >
                            {countAllocations > 0 && (
                              <ButtonWithIcon>
                                <AddIcon
                                  accentHeight={16}
                                  style={{ fontSize: "1.5rem", fill: "white" }}
                                />
                              </ButtonWithIcon>
                            )}
                            <button
                              style={{
                                cursor: ` ${
                                  countAllocations == 0 && "default"
                                }`,
                              }}
                            >
                              {countAllocations > 0 && "Apontar "}
                              {countAllocations} resultado(s)
                            </button>
                          </div>
                        </>
                      )}
                    </FormLabelStyled>

                    <RadioGroupStyled
                      row
                      aria-labelledby="demo-controlled-radio-buttons-group"
                      name="controlled-radio-buttons-group"
                      value={valueCategories}
                      onChange={handleChangeCategories}
                    >
                      <FormControlLabelStyled
                        value={"1"}
                        control={<Radio />}
                        label="Colaboradores"
                      />
                      <FormControlLabelStyled
                        value={"2"}
                        control={<Radio />}
                        label="Projetos"
                      />
                      <FormControlLabelStyled
                        value={"3"}
                        control={<Radio />}
                        label="Clientes"
                      />
                      <FormControlLabelStyled
                        value={"4"}
                        control={<Radio />}
                        label="Função"
                      />
                      <FormControlLabelStyled
                        value={"5"}
                        control={<Radio />}
                        label="Área"
                      />
                      <FormControlLabelStyled
                        value={"6"}
                        control={<Radio />}
                        label="Centro de Custo"
                      />
                    </RadioGroupStyled>
                  </FormControl>
                </MenuItem>
                {valueCategories === "1" && (
                  <MenuItem
                    style={{ display: "flex", alignItems: "center" }}
                    onKeyDown={(e) => {
                      e.stopPropagation();
                    }}
                  >
                    <TextField
                      fullWidth
                      value={searchResource}
                      onChange={handleChangeResource}
                      label="Colaboradores"
                      placeholder="Filtro de busca livre"
                      variant="standard"
                    />
                    <button
                      style={{
                        background: "none",
                        border: "0",
                        lineHeight: "0",
                        marginTop: "20px",
                        marginLeft: "5px",
                      }}
                    >
                      <img src={iconLupa} alt="" />
                    </button>
                  </MenuItem>
                )}

                {valueCategories === "3" && (
                  <MenuItem
                    onKeyDown={(e) => {
                      e.stopPropagation();
                    }}
                  >
                    <FormControl fullWidth>
                      <Autocomplete
                        multiple
                        limitTags={3}
                        options={clients}
                        getOptionLabel={(option) => option.value}
                        disableCloseOnSelect
                        isOptionEqualToValue={(option, value) =>
                          option.key === value.key
                        }
                        value={clientSelected || []}
                        inputValue={customerInputValue}
                        onInputChange={(event, newInputValue, reason) => {
                          if (reason === 'reset') {
                            return;
                          } else if (reason === 'input') {
                            setCustomerInputValue(newInputValue);
                          } else if (reason === 'clear') {
                            setCustomerInputValue('');
                          }
                        }}
                        onChange={(event, newValue) => {
                          handleResetFilters();
                          setStorageSearchParamsAllocationsMap();
                          setClientSelected(newValue);
                        }}
                        noOptionsText="Sem opções"
                        renderOption={(props, option, { selected }) => {
                          const { key, ...optionProps } = props;
                          return (
                            <li key={option.key} {...optionProps}>
                              <Checkbox
                                style={{ marginRight: 8 }}
                                checked={selected}
                              />
                              {option.value}
                            </li>
                          );
                        }}
                        renderInput={(params) => (
                          <TextField {...params} label="Clientes" />
                        )}
                      />
                    </FormControl>
                  </MenuItem>
                )}

                {valueCategories === "2" && (
                  <MenuItem
                    onKeyDown={(e) => {
                      e.stopPropagation();
                    }}
                  >
                    <FormControl fullWidth>
                      <Autocomplete
                        multiple
                        limitTags={3}
                        options={projects}
                        getOptionLabel={(option) => option.value}
                        disableCloseOnSelect
                        isOptionEqualToValue={(option, value) =>
                          option.key === value.key
                        }
                        value={projectSelected || []}
                        onChange={(event, newValue) => {
                          handleResetFilters();
                          setStorageSearchParamsAllocationsMap();
                          setProjectSelected(newValue);
                        }}
                        inputValue={projectInputValue}
                        onInputChange={(event, newInputValue, reason) => {
                          if (reason === 'reset') {
                            return;
                          } else if (reason === 'input') {
                            setProjectInputValue(newInputValue);
                          } else if (reason === 'clear') {
                            setProjectInputValue('');
                          }
                        }}
                        noOptionsText="Sem opções"
                        renderOption={(props, option, { selected }) => {
                          const { key, ...optionProps } = props;
                          return (
                            <li key={option.key} {...optionProps}>
                              <Checkbox
                                style={{ marginRight: 8 }}
                                checked={selected}
                              />
                              {option.value}
                            </li>
                          );
                        }}
                        renderInput={(params) => (
                          <TextField {...params} label="Projetos" />
                        )}
                      />
                    </FormControl>
                  </MenuItem>
                )}

                {valueCategories === "4" && (
                  <MenuItem
                    onKeyDown={(e) => {
                      e.stopPropagation();
                    }}
                  >
                    <FormControl fullWidth>
                      <Autocomplete
                        multiple
                        limitTags={3}
                        options={positions}
                        getOptionLabel={(option) => option.value}
                        disableCloseOnSelect
                        isOptionEqualToValue={(option, value) =>
                          option.key === value.key
                        }
                        value={positionSelected || []}
                        noOptionsText="Sem opções"
                        inputValue={positionInputValue}
                        onInputChange={(event, newInputValue, reason) => {
                          if (reason === 'reset') {
                            return;
                          } else if (reason === 'input') {
                            setPositionInputValue(newInputValue);
                          } else if (reason === 'clear') {
                            setPositionInputValue('');
                          }
                        }}
                        onChange={(event, newValue) => {
                          handleResetFilters();
                          setStorageSearchParamsAllocationsMap();
                          setPositionSelected(newValue);
                        }}
                        renderOption={(props, option, { selected }) => {
                          const { key, ...optionProps } = props;
                          return (
                            <li key={option.key} {...optionProps}>
                              <Checkbox
                                style={{ marginRight: 8 }}
                                checked={selected}
                              />
                              {option.value}
                            </li>
                          );
                        }}
                        renderInput={(params) => (
                          <TextField {...params} label="Função" />
                        )}
                      />
                    </FormControl>
                  </MenuItem>
                )}

                {valueCategories === "5" && (
                  <MenuItem
                    onKeyDown={(e) => {
                      e.stopPropagation();
                    }}
                  >
                    <FormControl fullWidth>
                      <Autocomplete
                        multiple
                        limitTags={3}
                        options={areas}
                        getOptionLabel={(option) => option.value}
                        disableCloseOnSelect
                        isOptionEqualToValue={(option, value) =>
                          option.key === value.key
                        }
                        value={areaSelected || []}
                        inputValue={areaInputValue}
                        onInputChange={(event, newInputValue, reason) => {
                          if (reason === 'reset') {
                            return;
                          } else if (reason === 'input') {
                            setAreaInputValue(newInputValue);
                          } else if (reason === 'clear') {
                            setAreaInputValue('');
                          }
                        }}
                        onChange={(event, newValue) => {
                          handleResetFilters();
                          setStorageSearchParamsAllocationsMap();
                          setAreaSelected(newValue);
                        }}
                        noOptionsText="Sem opções"
                        renderOption={(props, option, { selected }) => {
                          const { key, ...optionProps } = props;
                          return (
                            <li key={option.key} {...optionProps}>
                              <Checkbox
                                style={{ marginRight: 8 }}
                                checked={selected}
                              />
                              {option.value}
                            </li>
                          );
                        }}
                        renderInput={(params) => (
                          <TextField {...params} label="Área" />
                        )}
                      />
                    </FormControl>
                  </MenuItem>
                )}

                {valueCategories === "6" && (
                  <MenuItem
                    onKeyDown={(e) => {
                      e.stopPropagation();
                    }}
                  >
                    <FormControl fullWidth>
                      <Autocomplete
                        multiple
                        limitTags={3}
                        options={costCenters}
                        getOptionLabel={(option) => option.value}
                        disableCloseOnSelect
                        isOptionEqualToValue={(option, value) =>
                          option.key === value.key
                        }
                        value={costCenterSelected || []}
                        inputValue={costCenterInputValue}
                        onInputChange={(event, newInputValue, reason) => {
                          if (reason === 'reset') {
                            return;
                          } else if (reason === 'input') {
                            setCostCenterInputValue(newInputValue);
                          } else if (reason === 'clear') {
                            setCostCenterInputValue('');
                          }
                        }}
                        onChange={(event, newValue) => {
                          handleResetFilters();
                          setStorageSearchParamsAllocationsMap();
                          setCostCenterSelected(newValue);
                        }}
                        noOptionsText="Sem opções"
                        renderOption={(props, option, { selected }) => {
                          const { key, ...optionProps } = props;
                          return (
                            <li key={option.key} {...optionProps}>
                              <Checkbox
                                style={{ marginRight: 8 }}
                                checked={selected}
                              />
                              {option.value}
                            </li>
                          );
                        }}
                        renderInput={(params) => (
                          <TextField {...params} label="Centro de Custo" />
                        )}
                      />
                    </FormControl>
                  </MenuItem>
                )}
              </Menu>
            </div>
          </WrapperButtons>

          <DatePicker
            value={date}
            onChange={handleDateChange}
            label={"mês e ano"}
            views={["year", "month"]}
            openTo="year"
          />

          {/* <PaginationButton
          intent="previous"
          isVisible={pageNum !== 0}
          onClick={onLoadPrevious}
          icon={<Icon iconName="arrowUp" width="16" height="16" />}
          pageNum={pageNum}
          pagesAmount={pagesAmount}
        /> */}
        </StyledLeftColumnHeader>
        {data?.map((item, index) => (
          <LeftColumnItem
            id={item.id}
            item={item.label}
            key={item.id}
            rows={rows[index]}
            onItemClick={onItemClick}
          />
        ))}
        {/* 
      <PaginationButton
        intent="next"
        isVisible={pageNum !== pagesAmount - 1}
        onClick={onLoadNext}
        icon={<Icon iconName="arrowDown" width="16" height="16" />}
        pageNum={pageNum}
        pagesAmount={pagesAmount}
      /> */}
      </StyledWrapper>
      <ModalFormAlocation
        dataAllocation={{
          startDate: new Date(),
          endDate: new Date(),
          title: "",
          isProject: true,
        }}
        open={openModal}
        handleClose={handleCloseModal}
        wasOpenedByTheFilter={true}
      />
    </>
  );
};

export default LeftColumn;
